const ngoConfig = {
  businessName: "HopeForward Foundation",
  businessCategory: "Non-Profit Organization & NGO",
  tagline: "Empowering Lives, Building Futures",
  description:
    "HopeForward Foundation is a registered non-profit organization dedicated to uplifting underprivileged communities through education, healthcare, women empowerment, and sustainable livelihood programs.",
  mission:
    "To create a just and equitable society where every individual has access to education, healthcare, and opportunities to thrive.",
  vision:
    "A world free from poverty, inequality, and injustice — where every human being lives with dignity and hope.",
  logo: null,
  favicon: null,
  theme: {
    primaryColor: "#e76f51",
    secondaryColor: "#264653",
    accentColor: "#2a9d8f",
    backgroundColor: "#ffffff",
    textColor: "#1a1a1a",
    darkBackground: "#0d1b2a",
    darkText: "#f0f4f8",
    borderRadius: "12px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },
  darkModeEnabled: true,
  defaultDarkMode: false,
  seo: {
    title: "HopeForward Foundation | NGO for Education & Empowerment",
    description:
      "HopeForward Foundation works to uplift underprivileged communities through education, healthcare, and women empowerment. Join us in making a difference.",
    keywords:
      "NGO, non-profit, charity, education, healthcare, women empowerment, donate, volunteer, hopeforward",
    ogImage:
      "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=1200&q=80",
    twitterCard: "summary_large_image",
  },
  contact: {
    phone: "+91 98765 99999",
    whatsapp: "919876599999",
    email: "connect@hopeforward.org",
    website: "www.hopeforward.org",
    address: "12, Seva Marg, Civil Lines, New Delhi - 110054",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d241317.11609823277!2d72.74109995709657!3d19.08250589563531!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c6306644edc1%3A0x5da4ed8f8d648c69!2sMumbai%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1718000000000",
  },
  businessHours: [
    { day: "Monday – Friday", hours: "9:00 AM – 6:00 PM" },
    { day: "Saturday", hours: "10:00 AM – 3:00 PM" },
    { day: "Sunday", hours: "Closed" },
  ],
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    linkedin: "https://linkedin.com",
    youtube: "https://youtube.com",
    twitter: "https://twitter.com",
  },
  hero: {
    heading: "Together We Can Change the World",
    subheading:
      "Join us in our mission to empower underprivileged communities through education, healthcare, and sustainable livelihoods.",
    ctaPrimary: { label: "Donate Now", link: "/ngo/contact" },
    ctaSecondary: { label: "Our Programs", link: "/ngo/services" },
    images: [
      "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=1400&q=80",
      "https://images.unsplash.com/photo-1509099836639-18ba1795216d?w=1400&q=80",
      "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=1400&q=80",
    ],
  },
  about: {
    heading: "About HopeForward Foundation",
    subheading: "Serving Communities Since 2005",
    body: "For nearly two decades, HopeForward Foundation has been on the ground, working with the most vulnerable communities across India. From rural villages to urban slums, our 200+ dedicated volunteers and staff deliver impactful programs that create lasting change in the lives of thousands every year.",
    highlights: [
      "Registered Under FCRA & 80G",
      "200+ Active Volunteers",
      "18 States Covered",
      "ISO 9001:2015 Certified NGO",
    ],
    image:
      "https://images.unsplash.com/photo-1509099836639-18ba1795216d?w=800&q=80",
  },
  services: [
    {
      id: 1,
      icon: "FaGraduationCap",
      title: "Education for All",
      description:
        "Free schooling, scholarships, digital literacy, and after-school tutoring for underprivileged children.",
      image: "",
    },
    {
      id: 2,
      icon: "FaHeartbeat",
      title: "Community Healthcare",
      description:
        "Free medical camps, maternal health programs, nutrition drives, and mental health awareness initiatives.",
      image: "",
    },
    {
      id: 3,
      icon: "FaHandsHelping",
      title: "Women Empowerment",
      description:
        "Skill development, self-help groups, microfinance support, and legal aid for women in need.",
      image: "",
    },
    {
      id: 4,
      icon: "FaLeaf",
      title: "Environment & Sustainability",
      description:
        "Tree plantation drives, clean water projects, waste management, and eco-awareness campaigns.",
      image: "",
    },
    {
      id: 5,
      icon: "FaHome",
      title: "Shelter & Relief",
      description:
        "Emergency disaster relief, temporary shelter, food distribution, and rehabilitation support.",
      image: "",
    },
    {
      id: 6,
      icon: "FaChartLine",
      title: "Livelihood Programs",
      description:
        "Vocational training, entrepreneurship support, and job placement for youth and adults.",
      image: "",
    },
  ],
  stats: [
    { value: 150000, label: "Lives Impacted", suffix: "+" },
    { value: 200, label: "Active Volunteers", suffix: "+" },
    { value: 18, label: "States Covered", suffix: "" },
    { value: 19, label: "Years of Service", suffix: "+" },
  ],
  whyUs: {
    heading: "Why Support HopeForward?",
    subheading: "Your contribution creates real, measurable change",
    points: [
      {
        icon: "FaShieldAlt",
        title: "100% Transparent",
        description:
          "Every rupee is accounted for. Annual reports and audited financials are publicly available.",
      },
      {
        icon: "FaHandsHelping",
        title: "Grassroots Impact",
        description:
          "We work directly with communities — no middlemen, maximum impact on the ground.",
      },
      {
        icon: "FaGraduationCap",
        title: "Proven Programs",
        description:
          "Our programs are evidence-based and regularly evaluated for effectiveness and reach.",
      },
      {
        icon: "FaLeaf",
        title: "Sustainable Change",
        description:
          "We build community capacity so change continues long after our programs end.",
      },
    ],
  },
  gallery: [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=800&q=80",
      alt: "Community Outreach",
      category: "Outreach",
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1509099836639-18ba1795216d?w=800&q=80",
      alt: "Education Program",
      category: "Education",
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=800&q=80",
      alt: "Volunteer Drive",
      category: "Volunteers",
    },
    {
      id: 4,
      src: "https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?w=800&q=80",
      alt: "Medical Camp",
      category: "Healthcare",
    },
    {
      id: 5,
      src: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=800&q=80",
      alt: "Women Empowerment Workshop",
      category: "Empowerment",
    },
    {
      id: 6,
      src: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800&q=80",
      alt: "Tree Plantation Drive",
      category: "Environment",
    },
    {
      id: 7,
      src: "https://images.unsplash.com/photo-1593113598332-cd288d649433?w=800&q=80",
      alt: "Food Distribution",
      category: "Relief",
    },
    {
      id: 8,
      src: "https://images.unsplash.com/photo-1491438590914-bc09fcaaf77a?w=800&q=80",
      alt: "Youth Skill Training",
      category: "Livelihood",
    },
  ],
  pricing: [
    {
      id: 1,
      name: "Friend",
      price: "₹500",
      period: "per month",
      features: [
        "Educate 1 Child / Month",
        "Donation Receipt",
        "Monthly Impact Newsletter",
        "80G Tax Exemption",
      ],
      highlighted: false,
    },
    {
      id: 2,
      name: "Champion",
      price: "₹2,000",
      period: "per month",
      features: [
        "Support 5 Children",
        "Healthcare Camp Contribution",
        "Quarterly Impact Report",
        "Certificate of Appreciation",
        "80G Tax Exemption",
      ],
      highlighted: true,
    },
    {
      id: 3,
      name: "Patron",
      price: "₹10,000",
      period: "per month",
      features: [
        "Sponsor a Full Program",
        "Named Recognition on Website",
        "Annual Impact Visit",
        "CSR Partnership Certificate",
        "80G Tax Exemption",
        "Dedicated Relationship Manager",
      ],
      highlighted: false,
    },
  ],
  testimonials: [
    {
      id: 1,
      name: "Sunita Devi",
      role: "Beneficiary, Women Empowerment Program",
      review:
        "HopeForward gave me the skills and confidence to start my own tailoring business. Today I support my family independently. I am forever grateful.",
      rating: 5,
      avatar:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=80",
    },
    {
      id: 2,
      name: "Ramesh Kumar",
      role: "Corporate Donor, TechCorp India",
      review:
        "We've been partnering with HopeForward for 3 years for our CSR initiatives. Their transparency and on-ground impact is unmatched. Highly recommended.",
      rating: 5,
      avatar:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&q=80",
    },
    {
      id: 3,
      name: "Priya Sharma",
      role: "Volunteer, Delhi Chapter",
      review:
        "Volunteering with HopeForward has been the most fulfilling experience of my life. The team is passionate, organised, and truly committed to the cause.",
      rating: 5,
      avatar:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&q=80",
    },
  ],
  team: [
    {
      id: 1,
      name: "Dr. Anand Mishra",
      role: "Founder & Executive Director",
      bio: "Social entrepreneur with 20+ years in community development and policy advocacy.",
      image:
        "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
    {
      id: 2,
      name: "Kavita Nair",
      role: "Director – Education Programs",
      bio: "Former UNICEF consultant specialising in child education and literacy.",
      image:
        "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
    {
      id: 3,
      name: "Arjun Tiwari",
      role: "Head of Field Operations",
      bio: "Manages ground-level programs across 18 states with 200+ volunteers.",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
    {
      id: 4,
      name: "Meena Pillai",
      role: "Women Empowerment Lead",
      bio: "Passionate advocate for gender equality and women's economic independence.",
      image:
        "https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&q=80",
      social: { linkedin: "#", twitter: "#" },
    },
  ],
  faq: [
    {
      id: 1,
      question: "Is my donation tax-exempt?",
      answer:
        "Yes. HopeForward Foundation is registered under Section 80G of the Income Tax Act. All donations are eligible for 50% tax exemption. You will receive an official receipt.",
    },
    {
      id: 2,
      question: "How can I volunteer with HopeForward?",
      answer:
        "We welcome volunteers for field programs, digital marketing, fundraising, and more. Fill out the volunteer form on our Contact page and our team will reach out within 48 hours.",
    },
    {
      id: 3,
      question: "How is my donation used?",
      answer:
        "85% of every donation goes directly to programs. 15% covers operational costs. Our audited annual reports are publicly available on our website.",
    },
    {
      id: 4,
      question: "Can companies partner with HopeForward for CSR?",
      answer:
        "Absolutely. We offer structured CSR partnerships aligned with your company's goals. Contact us for a customised CSR proposal.",
    },
    {
      id: 5,
      question: "Do you accept in-kind donations?",
      answer:
        "Yes, we accept books, stationery, clothes, medicines, and food items. Please contact us before sending to confirm current needs.",
    },
  ],
  cta: {
    heading: "Be the Change You Wish to See",
    subheading:
      "Your support — big or small — transforms lives. Donate, volunteer, or partner with us today.",
    buttonLabel: "Donate / Get Involved",
    buttonLink: "/ngo/contact",
  },
  footer: {
    tagline: "Empowering Lives, Building Futures.",
    copyright: `© ${new Date().getFullYear()} HopeForward Foundation. All Rights Reserved. | Reg. No. 12345/2005`,
    links: [
      { label: "Home", path: "/ngo" },
      { label: "Programs", path: "/ngo/services" },
      { label: "Gallery", path: "/ngo/gallery" },
      { label: "Contact", path: "/ngo/contact" },
    ],
  },
  productsLabel: "Merchandise & Donations",
  products: [
    { id: 1, name: "HopeForward Tote Bag", category: "Merchandise", price: 399, originalPrice: null, image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=600&q=80", description: "Eco-friendly canvas tote with HopeForward logo. 100% proceeds go to education programs.", badge: "Support Us", inStock: true },
    { id: 2, name: "Sponsor a Child – 1 Month", category: "Donations", price: 500, originalPrice: null, image: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=600&q=80", description: "Your ₹500 funds one child's education for a full month. Receive a thank-you certificate.", badge: "Most Impactful", inStock: true },
    { id: 3, name: "Awareness Wristband Pack", category: "Merchandise", price: 199, originalPrice: null, image: "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?w=600&q=80", description: "Set of 3 silicone wristbands in NGO colours. Wear your support with pride.", badge: null, inStock: true },
    { id: 4, name: "Annual Patron Donation", category: "Donations", price: 10000, originalPrice: null, image: "https://images.unsplash.com/photo-1532629345422-7515f3d16bb6?w=600&q=80", description: "Sponsor a full program for a year. Receive named recognition, annual report & impact visit.", badge: "Patron", inStock: true },
  ],
  sections: {
    hero: true,
    about: true,
    services: true,
    whyUs: true,
    stats: true,
    gallery: true,
    pricing: true,
    testimonials: true,
    team: true,
    faq: true,
    cta: true,
    contact: true,
    products: true,
    enquireMode: true,
  },
};

export default ngoConfig;
